import { defineStore } from "pinia";
import type {
  WebModelGetCountry,
  WebModelGetHub,
} from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { getIsoCountryCodeByIpAddress } from "~/model/api/pLCnextStoreFrontendAPI";
import { withLoading } from "~/helpers/withLoading";

interface State {
  userCountryIso: string | null;
  userCountry: WebModelGetCountry | null;
}

export const useUserCountryStore = defineStore("usercountry", {
  state: (): State => ({
    userCountryIso: null,
    userCountry: null,
  }),
  getters: {
    isUserCountryWhitelisted(state): boolean {
      return state.userCountry?.status === "Full";
    },
    getUserHub(state): WebModelGetHub | undefined {
      return state.userCountry?.hub;
    },
  },
  actions: {
    async findUserCountryIsoString(iso: string | null | undefined) {
      console.debug("loadUserCountry called with " + iso + " as iso code");

      // user country is already defined and not null or undefined => use it
      // otherwise resolve country from ipApi
      if (iso) {
        this.userCountryIso = iso;
      } else {
        try {
          const { data } = await withLoading(getIsoCountryCodeByIpAddress());
          console.info("ipapi resolved country to: ", data);
          this.userCountryIso = data;
        } catch (err) {
          console.error("ipapi failed: ", err);
          console.debug("falling back to Germany as user country");
          this.userCountryIso = "DE"; // final fallback
        }
      }

      // we want to set userCountry (country: countryIso) and countryCategory (whitelisted and so on)
    },
    async loadUserCountryFromIsoString(
      countryIsoString: string | null,
      countries: WebModelGetCountry[],
    ) {
      console.debug("loadUserCountryCategory called with ", countryIsoString);
      // after userCountry is set, we can load the category for the country
      if (!countries) {
        console.debug("Could not load countries, skipping category load.");
        return;
      }
      const country = countries.find(
        (country) => country.iso === countryIsoString,
      );
      if (!country) {
        console.debug(
          "Could not find country with iso " +
            countryIsoString +
            " in countries list, skipping category load.",
        );
        return;
      }
      this.userCountry = country;
    },

    clear() {
      this.$reset();
    },
  },
});
